import {
  TealiumEventCategory,
  TealiumEventNames,
  IMedia,
  HeartbeatIntervals,
  HeartbeatLabels,
  playerStateManager,
  PlayerStatus,
  ITealiumEvent,
} from '@4tn/core-audio-player-shared';

import { TealiumEvent } from '../tealium-event';

let timeoutId: ReturnType<typeof setTimeout>;
let currentTime: number;

const INITIAL_HEARTBEAT_STATE = {
  timeout: HeartbeatIntervals.ONE_MINUTE,
  startTimestamp: 0,
  stopTimestamp: 0,
  eventLabel: HeartbeatLabels.LABEL_1,
  elapsedTime: 0,
  resetCounter: false,
};

const getInitialHeartbeatState = () => ({ ...INITIAL_HEARTBEAT_STATE });

export const heartbeatState = getInitialHeartbeatState();

const updateHeartbeatState = (newTimeout: number, label: number) => {
  heartbeatState.startTimestamp = Date.now();
  heartbeatState.timeout = newTimeout;
  heartbeatState.eventLabel = label;
  heartbeatState.elapsedTime = 0;
};

const playerState = {
  contentId: '',
};

export const updateCurrentTime = (time: number) => {
  currentTime = Math.floor(time);
};

export const startCounter = (
  media: IMedia,
  trackLink: (eventData: ITealiumEvent) => void,
  wasConnectionLost: boolean
) => {
  const reset =
    heartbeatState.resetCounter ||
    (heartbeatState.stopTimestamp
      ? Date.now() - heartbeatState.stopTimestamp > HeartbeatIntervals.FORTYFIVE_MINUTES
      : false);
  if ((!wasConnectionLost && media?.contentId !== playerState.contentId) || reset) {
    Object.assign(heartbeatState, getInitialHeartbeatState());
    clearTimeout(timeoutId);
  }
  if (!wasConnectionLost) {
    playerState.contentId = media?.contentId;
  }

  const sendEvent = (timeout: number, label: number) => {
    updateHeartbeatState(timeout, label);
    timeoutId = setTimeout(() => {
      const { mediaMetadata, playerVersion } = playerStateManager.getState();

      const tealiumEvent = new TealiumEvent({
        eventName: TealiumEventNames.PLAYER_HEARTBEAT,
        eventCategory: TealiumEventCategory.PLAYER,
        eventLabel: heartbeatState.eventLabel,
        media: {
          mediaOffset: currentTime || 0,
        },
        player: {
          playerState: PlayerStatus.PLAY,
          playerVersion,
        },
        mediaMetadata,
      });
      trackLink(tealiumEvent.getEventData());

      switch (heartbeatState.eventLabel) {
        case HeartbeatLabels.LABEL_1:
          sendEvent(HeartbeatIntervals.SEVEN_MINUTES, HeartbeatLabels.LABEL_8);
          break;
        case HeartbeatLabels.LABEL_8:
          sendEvent(HeartbeatIntervals.SEVEN_MINUTES, HeartbeatLabels.LABEL_15);
          break;
        default:
          heartbeatState.eventLabel += HeartbeatLabels.LABEL_15;
          sendEvent(HeartbeatIntervals.FIFTEEN_MINUTES, heartbeatState.eventLabel);
          break;
      }
    }, timeout);
  };

  heartbeatState.elapsedTime += heartbeatState.stopTimestamp - heartbeatState.startTimestamp;
  const timeout = heartbeatState.timeout - heartbeatState.elapsedTime;
  heartbeatState.startTimestamp = Date.now();

  sendEvent(timeout, heartbeatState.eventLabel);
};

export const stopCounter = () => {
  heartbeatState.stopTimestamp = Date.now();
  clearTimeout(timeoutId);
};

export const resetCounter = () => {
  heartbeatState.resetCounter = true;
  clearTimeout(timeoutId);
};
